import React from 'react'
import RecommendationAdditionActions from 'src/mentor/components/EmrRelatedComponents/screeningRecommendation/components/RecommendationAdditionActions'
import RecommendationHeader from 'src/mentor/components/EmrRelatedComponents/screeningRecommendation/components/RecommendationHeader'
import {
  CreateRecommendationsContainer,
  RecommendationItemContainer,
} from 'src/mentor/components/EmrRelatedComponents/screeningRecommendation/components/styledComponents'
import DiagnosticAssessmentSubSection from 'src/mentor/components/EmrRelatedComponents/screeningRecommendation/components/subSectionComponents/DiagnosticAssessmentSubSection'
import DieticianConsultationSubSection from 'src/mentor/components/EmrRelatedComponents/screeningRecommendation/components/subSectionComponents/DieticianConsultationSubSection'
import TherapyRecommendationSubSection from 'src/mentor/components/EmrRelatedComponents/screeningRecommendation/components/subSectionComponents/TherapyRecommendationSubSection'
import useScreeningRecommendationScreenerActions from 'src/mentor/components/EmrRelatedComponents/screeningRecommendation/hooks/useScreeningRecommendationScreenerActions'

export default function ScrRecommendations({
  screeningEmrSectionDef,
  screeningRecommendationSectionData,
  setScreeningRecommendationSectionData,
  sectionTitle = 'Screener Form (Recommendations)',
  showRedBorder = false,
}) {
  const subSections = screeningEmrSectionDef?.subSections
  const therapySubSection = subSections?.find((s) => s.code === 'THERAPY')
  const dieticianSubSection = subSections?.find((s) => s.code === 'DIETICIAN_CONSULTATION')
  const diagnosticAssessmentsSubSection = subSections?.find(
    (s) => s.code === 'DIAGNOSTIC_ASSESSMENT',
  )

  const therapyRecommendations = screeningRecommendationSectionData?.subSections?.filter(
    (section) => section.subSectionCode === 'THERAPY',
  )

  const diagnosticAssessments = screeningRecommendationSectionData?.subSections?.filter(
    (section) => section.subSectionCode === 'DIAGNOSTIC_ASSESSMENT',
  )

  const dieticianConsultations = screeningRecommendationSectionData?.subSections?.filter(
    (section) => section.subSectionCode === 'DIETICIAN_CONSULTATION',
  )

  const { createRecommendation, removeRecommendation, editRecommendation } =
    useScreeningRecommendationScreenerActions({
      setScreeningRecommendationSectionData,
    })

  function handleChangeSectionFieldValue(subSectionCode, orderNumber, fieldCode, newValueOrPrev) {
    editRecommendation(
      (prev) => {
        if (typeof newValueOrPrev === 'function') {
          return {
            ...prev,
            [fieldCode]: newValueOrPrev(prev?.[fieldCode] || {}),
          }
        } else {
          return {
            ...prev,
            [fieldCode]: newValueOrPrev,
          }
        }
      },
      subSectionCode,
      orderNumber,
    )
  }

  return (
    <CreateRecommendationsContainer showRedBorder={showRedBorder}>
      <div className="px-2 pt-2">
        <h6 style={{ color: '#000' }}>{sectionTitle}</h6>
        {showRedBorder && <span className="fw-normal fs-7">Please review the recommendations</span>}
      </div>
      <hr></hr>
      <div className="d-flex flex-column gap-2 mb-2">
        <RecommendationAdditionActions createRecommendation={createRecommendation} />
      </div>
      <div className="d-flex flex-column gap-1">
        {therapyRecommendations?.map((recommendation, index) => (
          <RecommendationItemContainer key={index}>
            <RecommendationHeader
              handleRemoveRecommendation={removeRecommendation}
              recommendationType="THERAPY"
              recommendationOrderNumber={recommendation.orderNumber}
              recommendationTitle="Therapy"
            />
            <TherapyRecommendationSubSection
              fieldValues={recommendation?.values}
              handleFieldValueChange={(prevOrObj, fieldCode) => {
                handleChangeSectionFieldValue(
                  recommendation.subSectionCode,
                  recommendation.orderNumber,
                  fieldCode,
                  prevOrObj,
                )
              }}
              subSection={therapySubSection}
            />
          </RecommendationItemContainer>
        ))}
        {diagnosticAssessments?.map((recommendation, index) => (
          <RecommendationItemContainer key={index}>
            <RecommendationHeader
              handleRemoveRecommendation={removeRecommendation}
              recommendationType="DIAGNOSTIC_ASSESSMENT"
              recommendationOrderNumber={recommendation.orderNumber}
              recommendationTitle={`Diagnostic Assessment`}
            />
            <DiagnosticAssessmentSubSection
              fieldValues={recommendation?.values}
              handleFieldValueChange={(prevOrObj, fieldCode) => {
                handleChangeSectionFieldValue(
                  recommendation.subSectionCode,
                  recommendation.orderNumber,
                  fieldCode,
                  prevOrObj,
                )
              }}
              subSection={diagnosticAssessmentsSubSection}
            />
          </RecommendationItemContainer>
        ))}
        {dieticianConsultations?.map((recommendation, index) => (
          <RecommendationItemContainer key={index}>
            <RecommendationHeader
              handleRemoveRecommendation={removeRecommendation}
              recommendationType="DIETICIAN_CONSULTATION"
              recommendationOrderNumber={recommendation.orderNumber}
              recommendationTitle={`Dietician Consultation`}
            />
            <DieticianConsultationSubSection
              fieldValues={recommendation?.values}
              handleFieldValueChange={(prevOrObj, fieldCode) => {
                handleChangeSectionFieldValue(
                  recommendation.subSectionCode,
                  recommendation.orderNumber,
                  fieldCode,
                  prevOrObj,
                )
              }}
              subSection={dieticianSubSection}
            />
          </RecommendationItemContainer>
        ))}
      </div>
    </CreateRecommendationsContainer>
  )
}
